import { Component, Input } from '@angular/core'
import { MatCardContent } from '@angular/material/card'
import { NgStyle } from '@angular/common'

@Component({
	selector: 'card-content',
	templateUrl: './CardContent.Component.html',
	imports: [MatCardContent, NgStyle],
})
export class CardContentComponent {
	@Input() public styles: { [key: string]: string | number }
}
